import { applyBadges, useBadgePrefs } from '../badges';
/**
 * Mediaflags zoals in Kodi-skins: duidelijke vlaggetjes voor resolutie, HDR en audio,
 * in plaats van platte tekst. Typografisch (geen merklogo's).
 */
function kindOf(b: string): { cls: string; top?: string; main: string } {
  if (b === '4K') return { cls: 'mf-res', top: 'Ultra HD', main: '4K' };
  if (b === '1080p') return { cls: 'mf-res', top: 'Full HD', main: '1080p' };
  if (b.startsWith('Dolby Vision')) return { cls: 'mf-dv', top: 'Dolby', main: `Vision${b.includes(' P') ? ` ${b.split(' ').pop()}` : ''}` };
  if (b === 'HDR10+') return { cls: 'mf-hdr', top: 'HDR', main: '10+' };
  if (/^HDR/.test(b)) return { cls: 'mf-hdr', top: 'HDR', main: b.replace('HDR', '') || 'HDR' };
  if (b === 'Atmos') return { cls: 'mf-audio', top: 'Dolby', main: 'Atmos' };
  if (b === 'TrueHD') return { cls: 'mf-audio', top: 'Dolby', main: 'TrueHD' };
  if (b.startsWith('DTS')) return { cls: 'mf-audio', top: 'DTS', main: b.replace(/^DTS-?/, '') || 'DTS' };
  return { cls: '', main: b };
}

export function MediaFlags({ flags }: { flags: string[] }) {
  if (!flags.length) return null;
  return (
    <span className="mediaflags" aria-label={flags.join(', ')}>
      {flags.map((b) => {
        const k = kindOf(b);
        return (
          <span key={b} className={`mf ${k.cls}`} aria-hidden="true">
            {k.top && <small>{k.top}</small>}
            <strong>{k.main}</strong>
          </span>
        );
      })}
    </span>
  );
}

/** Kleine vlaggen op een tegel. Aan/uit en positie komen uit de skin (data-mflags op <html>). */
export function TileFlags({ flags }: { flags: { label: string; kind: 'res' | 'hdr' | 'audio' }[] }) {
  // Badge Studio: welke badges op posters, en in welke volgorde
  const bp = useBadgePrefs();
  const { badges } = applyBadges(flags.map((f) => f.label), bp, 'posters');
  const shown = badges.map((b) => flags.find((f) => f.label === b.label)!).filter(Boolean);
  if (!shown.length) return null;
  return (
    <span className={`tile-flags${bp.style === 'color' || bp.style === 'logo' ? ' tf-colored' : ''}`} aria-hidden="true">
      {shown.map((f) => <span key={f.label} className={`tf tf-${f.kind}`}>{f.label}</span>)}
    </span>
  );
}

/** Score op een tegel (0-10). Aan/uit komt uit Instellingen → Metadata (data-mscore op <html>). */
export function TileScore({ score }: { score?: number | null }) {
  if (!score) return null;
  return <span className="tile-score" aria-hidden="true">★ {score.toFixed(1).replace('.', ',')}</span>;
}
